<template lang="pug">
md-input-container
  label(for='network') Age
  md-select(name='age', :multiple='multiple', v-model='selected', @selected='onSelected')
    md-option(v-for='age in ages', :value='age.key', :key='age.key') {{ age.value }}
</template>

<script>
  import { metrics } from '../../assets/data/demographics';

  export default {
    props: {
      value: {
        type: [String, Array],
        required: true
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        ages: metrics.ages
      };
    },
    methods: {
      onSelected(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/demographic/AgeSelector.vue